var video_viewer_default = {
  "video_player": "_4JE6D",
  "videoOverlay": "_4TfVM",
  "video_container": "gyo3N"
};
export {
  video_viewer_default as default
};
//# sourceMappingURL=video-viewer-scss.js.map
